var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExclamation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.45508 2.01013C9.45508 1.45701 9.0082 1.01013 8.45508 1.01013C7.90195 1.01013 7.45508 1.45701 7.45508 2.01013V10.0101C7.45508 10.5633 7.90195 11.0101 8.45508 11.0101C9.0082 11.0101 9.45508 10.5633 9.45508 10.0101V2.01013ZM8.45508 15.0101C8.7866 15.0101 9.10454 14.8784 9.33896 14.644C9.57338 14.4096 9.70508 14.0917 9.70508 13.7601C9.70508 13.4286 9.57338 13.1107 9.33896 12.8762C9.10454 12.6418 8.7866 12.5101 8.45508 12.5101C8.12356 12.5101 7.80562 12.6418 7.57119 12.8762C7.33677 13.1107 7.20508 13.4286 7.20508 13.7601C7.20508 14.0917 7.33677 14.4096 7.57119 14.644C7.80562 14.8784 8.12356 15.0101 8.45508 15.0101Z",
    fill: "#C7432B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamation);
export default __webpack_public_path__ + "static/media/Exclamation.be4275ad1f62b36dc2f0c5496e32375f.svg";
export { ForwardRef as ReactComponent };